import { createFileRoute } from "@tanstack/react-router";
import { EnterNamePlateInfo } from "@/components/installFlowV2/enter-name-plate-info";
import { z } from "zod";

export const Route = createFileRoute("/installFlow/enter-name-plate-info")({
  component: EnterNamePlateInfo,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
    installSensorKitSerialNumber: z.string().optional(),
  }),
});
